import { Component, Input, OnInit, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { XsI18nPipe } from '@nx-fe/pipes';
import { FeatureToggleService, hd, TicketService } from '@nx-fe/services';
import { AttachmentService } from 'app/modules/ticket/services/attachment.service';
import { Activity, AttachmentActivity, UploadedFile, isAttachmentActivity, isDeviceCaptureActivity } from '../../../ticket.model';

@Component({
  selector: 'xs-attachment-media',
  templateUrl: './attachment-media.component.html',
  styleUrls: ['./attachment-media.component.scss'],
})

/** Controller for the attachment media component */
export class AttachmentMediaComponent implements OnInit, OnChanges {
  // public static $inject: string[] = ['saAttachmentService', 'saFeatureToggleService', '$log', '$window'];

  /** Attachment activity */
  @Input() activity: AttachmentActivity;

  /** Whether this is used to show a preview for the attachment */
  @Input() isThumbnail: boolean;

  /** Optional unique ID for the media tag used to reprsent the image/video in the DOM */
  @Input() mediaId: string;

  /** Optional CSS class to apply to media preview component */
  @Input() mediaClass: string;

  /** Image source URL (base64) */
  @Input() imageSrc: string;

  /** Video source URL (direct download/stream URL */
  @Input() videoSrc: string;

  @Input() isMediaRefreshed: boolean;

  constructor(private attachmentService: AttachmentService, private featureToggleService: FeatureToggleService) { }

  /** Called when component bindings are updated */
  ngOnChanges(changes: SimpleChanges) {
    // console.warn('attachment media changes', changes);
    if (changes.activity?.firstChange || changes.isMediaRefreshed?.currentValue) {
      this.setMediaImage(this.activity);
    }
  }

  ngOnInit() {}

  /** Determines if the attachment is a video */
  public isVideo = (): boolean => {
    return (!this.isThumbnail) ? this.attachmentService.isSupportedVideoType(this.attachmentService.getFile(this.activity)?.fileName) : false;
  }

  private setMediaImage = (activity: AttachmentActivity) => {
    // Clear source when activity changes
    // this.imageSrc = this.videoSrc = '';
    if (activity.activityId) {
      // A new activity has been set, so fetch the attachment
      const thumbnail = this.getThumbnailFromActivity(activity);
      if (this.isThumbnail && thumbnail) {
        this.imageSrc = 'data:image/png;base64,' + thumbnail;
      } else {
        if (!this.isThumbnail) {
          return;
        }
        const file: UploadedFile = this.attachmentService.getFile(activity);
        if (file) {
          const temp = {
            activityId: activity.activityId,
            activityTypeId: activity.activityTypeId,
            fileName: file.fileName,
            fileSize: file.fileSize,
            fileId: file.fileId,
            displayName: file.displayName,
            description: '',
            // thumbnail: string,
          } as AttachmentActivity;
          this.attachmentService.fetchMediaUrl(temp, this.isThumbnail).then((url: string) => {
            if (this.isVideo()) {
              this.videoSrc = url;
            } else {
              this.imageSrc = url;
            }
          });
        }
      }
    }

  }

  private getThumbnailFromActivity = (activity: AttachmentActivity) => {
    return isDeviceCaptureActivity(activity) && activity.details?.files?.length > 0 ?
      activity.details.files[0].thumbnail :
      activity.details?.thumbnail;
  }
}
